import React from "react";
import { motion } from "framer-motion";

const tech = [
  { name: "React", icon: "⚛️" },
  { name: "FastAPI", icon: "⚡" },
  { name: "Python", icon: "🐍" },
  { name: "Docker", icon: "🐳" },
  { name: "ML / AI", icon: "🤖" },
  { name: "PostgreSQL", icon: "🐘" },
  { name: "Tailwind", icon: "🎨" },
  { name: "Linux", icon: "🐧" },
  { name: "Nginx", icon: "🌐" },
];

// Удваиваем массив для бесшовной анимации
const duplicatedTech = [...tech, ...tech];

export default function TechStack() {
  return (
    <section className="py-10 bg-slate-50 border-y border-slate-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-6 text-center">
        <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400">
          Наш технологический стек
        </p>
      </div>

      <div className="relative flex">
        <motion.div
          className="flex gap-12 items-center whitespace-nowrap"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            ease: "linear",
            duration: 20,
            repeat: Infinity,
          }}
        >
          {duplicatedTech.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 group cursor-default"
            >
              <span className="text-3xl grayscale group-hover:grayscale-0 transition-all duration-300 transform group-hover:scale-110">
                {item.icon}
              </span>
              <span className="text-xl font-black text-slate-300 group-hover:text-slate-900 transition-colors uppercase italic tracking-tighter">
                {item.name}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
